import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '@shared';

import { EmployeesRestrictionsModalComponent } from './employees-restrictions-modal.component';

@NgModule({
    imports: [CommonModule, SharedModule],
    declarations: [EmployeesRestrictionsModalComponent]
})
export class EmployeesRestrictionsModalModule {}
